<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="text-white">Hoy es: {{ new Date() | toReadableDate }}</h4>
      <b-button @click="cargarReservas">
        <b-icon icon="arrow-clockwise"> </b-icon>Actualizar reservas
      </b-button>
    </div>
    <!-- MODAL -->
    <b-modal
      v-for="reserva of reservasAMostrar"
      centered
      :key="reserva.id"
      :ref="reserva.id"
      hide-footer
      :title="`${reserva.nombre} | ${reserva.id}`"
      size="lg"
    >
      <b-card v-if="reservaModal" class="ml-2 pl-4 pt-2">
        <h4>{{ reservaModal.experiencia }}</h4>
        <hr />
        <ul style="line-height: 2">
          <li>
            <strong>Estado:</strong>
            {{ reservaModal.estado }}
          </li>
          <li>
            <strong>Procedencia:</strong>
            {{ reservaModal.procedencia }}
          </li>
          <li>
            <strong>N° de Viajeros:</strong>
            {{ reservaModal.viajeros }}
          </li>
          <li v-if="reservaModal.detalleViajeros">
            <strong>Detalle viajeros:</strong>
            <ul class="ml-4">
              <li>
                <strong class="pr-2">Adulto:</strong
                >{{ reservaModal.detalleViajeros.adultos.cantidad }}
              </li>
              <template v-if="reservaModal.detalleViajeros.niños">
                <li
                  v-for="niño in reservaModal.detalleViajeros.niños"
                  :key="niño.nombre"
                >
                  <strong class="pr-2">{{ niño.nombre }}:</strong>
                  {{ niño.cantidad }}
                </li>
              </template>
            </ul>
          </li>
          <li v-if="reservaModal.permiteAbono">
            <strong>Abona con:</strong>
            {{ reservaModal.abono.porcentajeAbono }}%
          </li>
          <li v-if="reservaModal.permiteAbono">
            <strong>Primera cuota:</strong> ${{
              reservaModal.abono.primeraCuota
            }}
          </li>
          <li v-if="reservaModal.permiteAbono">
            <strong>Segunda cuota:</strong> ${{
              reservaModal.abono.segundaCuota
            }}
          </li>
          <li><strong>Valor Total:</strong> {{ reservaModal.total }}</li>
          <li v-if="reservaModal.temporadas">
            <strong>Temporadas en reserva:</strong>
            <span
              v-for="(temporada, i) of reservaModal.temporadas"
              :key="temporada"
            >
              {{ temporada }}
              <span
                v-if="
                  reservaModal.temporadas.length > 1 &&
                  i < reservaModal.temporadas.length - 1
                "
                >,</span
              >
            </span>
          </li>
          <li><strong>Idioma:</strong> {{ reservaModal.idioma }}</li>
          <li>
            <strong>Fecha de Inicio:</strong>
            {{ reservaModal.fecha }} a las {{ reservaModal.horaInicio }}hrs.
          </li>
          <!-- <li>
              <strong>Hora de Inicio:</strong>
              {{ reservaModal.horaInicio }}
            </li> -->
          <li v-if="reservaModal.fechaFin">
            <strong>Fecha de Término:</strong>
            {{ reservaModal.fechaFin }} a las {{ reservaModal.horaFin }}hrs.
          </li>
          <li v-else>
            <strong>Hora de Término:</strong>
            {{
              fechaFin({
                expName: reservaModal.experiencia,
                expID: reservaModal.experienciaId,
                fechaInicio: reservaModal.fecha,
                horaFin: reservaModal.horaFin,
              })
            }}
          </li>
          <li>
            <strong>Comentario:</strong>
            {{ reservaModal.comentarios }}
          </li>
          <li>
            <strong>¿Vegano o Vegetariano?:</strong>
            {{ reservaModal.vegano }}
          </li>
          <!-- <li>
              <strong>¿Quiere recibir promociones?:</strong>
              {{ reservaModal.promociones }}
            </li> -->
          <!-- <li>
              <strong>¿Es Referido?:</strong>
              {{ reservaModal.referencia }}
            </li> -->
        </ul>
      </b-card>
      <div>
        <b-button class="mt-3" block @click="cerrarModal(reserva.id)"
          >Cerrar</b-button
        >
      </div>
    </b-modal>

    <div class="calendar__wrapper">
      <FullCalendar :options="calendarOptions" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { db } from "../firebase.service";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  components: { FullCalendar },
  data() {
    return {
      reservasAMostrar: [],
      reservaModal: null,
      // Adjudicaciones Mercado Publico: eventos informativos en el calendario,
      // diferenciados visualmente (amarillo). No afectan reservas ni disponibilidad.
      adjudicaciones: [],
    };
  },
  computed: {
    ...mapState("reservaciones", [
      "reservaciones",
      "reservacionesPorConfirmar",
    ]),
    ...mapState(["experiencias"]),
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        events: [...this.calendarEvents, ...this.adjudicacionEvents],
        eventClick: (info) => {
          // Las adjudicaciones llevan sus datos en extendedProps; las reservas
          // se resuelven por id contra el store. Distinguimos por extendedProps.
          const adj = info.event.extendedProps && info.event.extendedProps.adjudicacion;
          if (adj) return this.verAdjudicacion(adj);
          this.verInfo(info.event.id);
        },
        displayEventTime: false,
        locale: "es",
        firstDay: 1,
        headerToolbar: {
          left: "prev",
          center: "title",
          right: "next",
        },
        titleFormat: { year: "numeric", month: "short" },
        fixedWeekCount: false,
      };
    },
    calendarEvents() {
      const reservas = this.reservasAMostrar;

      const events = [];
      for (const r of reservas) {
        try {
          const color = this.randomColor();
          // r.fecha y r.fechaFin YA estan normalizadas a ISO por cargarReservas.
          // Pintamos el rango COMPLETO de la estadia: desde el check-in (fecha)
          // hasta el check-out (fechaFin) INCLUIDO el dia de salida.
          //
          // Antes el evento terminaba en fechaFin a las 00:00 (muchas reservas
          // post-Astro graban horaFin=""), y FullCalendar corta ese ultimo dia
          // -> solo se veian las noches (ej. Cecilia: 29-jun -> 1-jul aparecia
          // solo hasta el 30). Ahora usamos eventos all-day y sumamos 1 dia al
          // `end` (que en all-day es EXCLUSIVO) para que el dia de salida quede
          // pintado. Mismo criterio que las adjudicaciones.
          const startMom = moment(r.fecha);
          if (!startMom.isValid()) continue;
          let checkoutMom;
          if (r.fechaFin) {
            const f = moment(r.fechaFin);
            if (f.isValid()) checkoutMom = f;
          }
          if (!checkoutMom) {
            // Sin fechaFin: derivar el dia de salida a partir de cantidadDias.
            const exp = (this.experiencias || []).find((e) => {
              if (r.experienciaId && e.id === r.experienciaId) return true;
              return e.titulo && r.experiencia && e.titulo.includes(r.experiencia);
            });
            const cantidadDias = exp && Number(exp.cantidadDias) > 0 ? Number(exp.cantidadDias) : 1;
            checkoutMom = moment(r.fecha).add(Math.max(0, cantidadDias - 1), "d");
          }
          if (!checkoutMom || !checkoutMom.isValid()) checkoutMom = startMom.clone();
          events.push({
            id: r.id,
            start: startMom.format("YYYY-MM-DD"),
            end: checkoutMom.clone().add(1, "d").format("YYYY-MM-DD"),
            allDay: true,
            title: `${this.nombreCliente(r.nombre)} - [${r.estado || "Sin estado"}] - ${r.experiencia}`,
            className: [color, "text-white"],
            borderColor: "#000",
          });
        } catch (e) { /* skip row que rompe — no tumba el calendario */ }
      }

      return events;
    },
    adjudicacionEvents() {
      const events = [];
      for (const a of this.adjudicaciones || []) {
        if (!a.checkIn) continue;
        const start = moment(a.checkIn);
        if (!start.isValid()) continue;
        // FullCalendar trata el `end` de un evento all-day como EXCLUSIVO,
        // por eso sumamos 1 dia para que el check-out quede pintado.
        let endStr;
        if (a.checkOut) {
          const end = moment(a.checkOut);
          if (end.isValid()) endStr = end.add(1, "d").format("YYYY-MM-DD");
        }
        events.push({
          id: "adj-" + a.id,
          start: start.format("YYYY-MM-DD"),
          end: endStr,
          allDay: true,
          title: `MP: ${a.institucion || "Adjudicacion"} — ${this.formatearCLP(a.montoAdjudicado)}`,
          className: ["evento-adjudicacion"],
          borderColor: "#000",
          extendedProps: { adjudicacion: a },
        });
      }
      return events;
    },
  },
  watch: {
    // Re-cargar el calendario cuando llegan datos del store (puede que
    // getReservas resuelva DESPUES de created() — onSnapshot async).
    reservaciones() { this.cargarReservas(); },
    reservacionesPorConfirmar() { this.cargarReservas(); },
  },
  methods: {
    ...mapActions("reservaciones", ["getReservas"]),
    randomColor() {
      const colores = [
        "bg-primary",
        "bg-purple",
        "bg-warning",
        "bg-danger",
        "bg-info",
        "bg-dark",
        "bg-success",
        "bg-orange",
        "bg-pink",
        "bg-yellowgreen",
        "bg-gray",
        "bg-secondary",
      ];

      const random = Math.round(Math.random() * (colores.length - 1 - 0));
      return colores[random];
    },
    cargarReservas() {
      // Pablo 15-jun-2026: solo mostrar reservas con al menos 1 pago.
      // Reservas inmediatas no se usan (legacy). Pagado = reserva total
      // realizada. Pendiente de segundo pago = abono ya pagado, falta
      // segunda cuota. Cualquier otro estado (Pendiente, Pendiente de
      // Pago, Pendiente de primer pago, Rechazado, etc.) NO va al
      // calendario porque la reserva aun no esta confirmada con pago.
      //
      // Diferencia con la version original pre-Astro: quitamos el
      // filtro de "fecha > 2021-07-01" para que Pablo vea historico +
      // futuro juntos en el mismo calendario.
      const ESTADOS_VALIDOS = ["Pagado", "Pendiente de segundo pago"];
      const reservas = Array.isArray(this.reservacionesPorConfirmar)
        ? JSON.parse(JSON.stringify(this.reservacionesPorConfirmar))
        : [];

      // Helper defensivo: el filter `fechaToISOString` espera formato
      // largo ("Lunes, 27 de Junio de 2026") y throw si llega otro shape.
      // Las reservas creadas post-Astro pueden venir con "27/06/2026"
      // (Bug 24, ya arreglado en sitio publico, pero docs viejos persisten).
      // Fallback parsea DD/MM/YYYY y DD-MM-YYYY para no perder reservas.
      const tryIso = (fecha, hora) => {
        try {
          const v = Vue.filter("fechaToISOString")(fecha, hora);
          if (v) return v;
        } catch (e) { /* fallthrough */ }
        if (typeof fecha === "string") {
          const m = fecha.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
          if (m) {
            const iso = `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
            const out = hora ? `${iso} ${hora}` : iso;
            const mom = moment(out);
            if (mom.isValid()) return mom.format();
          }
        }
        return null;
      };

      const filtro = reservas
        .filter((r) => {
          if (!ESTADOS_VALIDOS.includes(r.estado)) return false;
          if (!r.fecha) return false;
          const iso = tryIso(r.fecha);
          return iso && moment(iso).isValid();
        })
        .map((r) => {
          // Normalizamos ambas fechas a ISO aca para que `calendarEvents`
          // mas adelante NO tenga que llamar al filter (que throw con
          // formato corto). r.fechaFin se normaliza tambien — el mismo
          // bug de Richard Neira con "29/06/2026" rompia el computed.
          if (r.fecha) {
            r.fecha = tryIso(r.fecha, r.horaInicio) || r.fecha;
          }
          if (r.fechaFin) {
            r.fechaFin = tryIso(r.fechaFin, r.horaFin) || r.fechaFin;
          }
          return r;
        });

      this.reservasAMostrar = filtro;
    },
    verInfo(id) {
      const reservas = this.reservaciones.concat(
        this.reservacionesPorConfirmar
      );
      const infoReserva = reservas.find((r) => r.id == id);
      this.reservaModal = infoReserva;
      this.$refs[id][0].show();
    },
    cerrarModal(id) {
      const reservas = this.reservaciones.concat(
        this.reservacionesPorConfirmar
      );
      const infoReserva = reservas.find((r) => r.id == id);
      this.reservaModal = infoReserva;
      this.$refs[id][0].hide();
    },
    fechaFin({ expName, expID, fechaInicio, horaFin }) {
      const experiencia = this.experiencias.find((exp) => {
        if (expID) {
          return expID == exp.id;
        }

        return exp.titulo.includes(expName);
      });

      const cantidadDias = experiencia ? experiencia.cantidadDias : 1;
      const fechaVuelta =
        cantidadDias > 1
          ? moment(`${moment(fechaInicio).add(cantidadDias - 1, "d")}`)
              .hour(horaFin.split(":")[0])
              .minutes(horaFin.split(":")[1])
              .format()
          : fechaInicio;
      return fechaVuelta;
    },
    nombreCliente(nombre) {
      if (!nombre || typeof nombre !== "string") return "Cliente";
      const arrayNombre = nombre.split(" ").filter((n) => n.trim() != "");
      if (arrayNombre.length === 0) return "Cliente";
      const primerNombre = arrayNombre[0];
      const segundo = arrayNombre[1];
      // Defensivo: si solo hay 1 palabra, mostramos solo el primer nombre.
      if (!segundo) return primerNombre;
      const primeraLetraDeSegundaPalabra = segundo.slice(0, 1);
      return `${primerNombre} ${primeraLetraDeSegundaPalabra}`;
    },
    formatearCLP(valor) {
      const n = Number(valor);
      if (!Number.isFinite(n)) return "-";
      return "$ " + String(Math.round(n)).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " CLP";
    },
    verAdjudicacion(a) {
      const rango = a.checkOut ? `${a.checkIn} a ${a.checkOut}` : a.checkIn;
      alert(
        "ADJUDICACION MERCADO PUBLICO\n\n" +
        `Institucion: ${a.institucion || "-"}\n` +
        `ID OC: ${a.idOC || "-"}\n` +
        `Proveedor: ${a.proveedor || "-"}\n` +
        `Fechas: ${rango}\n` +
        `Monto: ${this.formatearCLP(a.montoAdjudicado)}\n\n` +
        (a.descripcion ? `Descripcion: ${a.descripcion}` : "")
      );
    },
  },
  async created() {
    // Asegurar que ambas collections (reservaciones + reservacionesPorConfirmar)
    // esten suscritas; el watcher recargara reservasAMostrar cuando lleguen.
    await this.getReservas();
    await this.cargarReservas();
    // Adjudicaciones Mercado Publico (coleccion propia, solo lectura aca).
    this.unsubscribeAdjudicaciones = db.collection("adjudicaciones").onSnapshot(
      (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => arr.push({ id: doc.id, ...doc.data() }));
        this.adjudicaciones = arr;
      },
      (err) => console.log("Error al cargar adjudicaciones en calendario:", err)
    );
  },
  beforeDestroy() {
    if (typeof this.unsubscribeAdjudicaciones === "function") {
      this.unsubscribeAdjudicaciones();
    }
  },
};
</script>

<style lang="scss">
@keyframes panToRight {
}

.bg-purple {
  background-color: purple !important;
}
.bg-gray {
  background-color: gray !important;
}
.bg-orange {
  background-color: orange !important;
}
.bg-yellowgreen {
  background-color: yellowgreen !important;
}
.bg-pink {
  background-color: pink !important;
}

// Evento de adjudicacion Mercado Publico: amarillo corporativo, texto oscuro
// para contraste, borde marcado para distinguirlo de las reservas.
.evento-adjudicacion {
  background-color: #ffaa01 !important;
  border-color: #000 !important;
  color: #1a1a1a !important;
  font-weight: 600;
  .fc-event-title,
  .fc-event-time {
    color: #1a1a1a !important;
  }
}

.calendar {
  &__wrapper {
    background: #fff;
    .fc {
      min-height: 60vh;
      &-event {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>